import React from "react";
import { Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";

import Home from "./components/landing/home";
import FAQ from "./components/landing/faq";
import RecentUpdate from "./components/landing/recentUpdate";
import TryNow from "./components/landing/TryNow";
import OurTeam from "./components/landing/ourTeam";
import Tutorial from "./components/landing/tutorial";
import Usecase1 from "./components/landing/tutorial/Usecase1";
import Usecase2 from "./components/landing/tutorial/Usecase2";
import Usecase3 from "./components/landing/tutorial/Usecase3";
import Usecase4 from "./components/landing/tutorial/Usecase4";
import TreeVisualisation from "./components/landing/tutorial/TreeVisualisation";
import TreePartitioning from "./components/landing/tutorial/TreePartitioning";
import ContactUs from "./components/landing/contact";
import MainApp from './components/main';

import dataConfigs from './data-configs.json'; // Import the JSON file

// Dynamically import themes
const themeContext = require.context('./themes', false, /\.js$/);
const themes = themeContext.keys().reduce((acc, path) => {
  const key = path.replace('./', '').replace('.js', ''); // Extract filename as the key
  acc[key] = themeContext(path).default; // Import and assign the theme
  return acc;
}, {});

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/tutorial" element={<Tutorial />} />
      <Route path="/FAQ" element={<FAQ />} />
      <Route path="/recentUpdate" element={<RecentUpdate />} />
      <Route path="/contactUs" element={<ContactUs />} />
      <Route path="/ourTeam" element={<OurTeam />} />
      <Route path="/tryNow" element={<TryNow />} />

      {/* Dynamically create routes for datasets */}
      {dataConfigs
        .filter((dataset) => dataset.active) // Only create routes for active datasets
        .map((dataset, index) => (
          <Route
            key={index}
            path={dataset.path}
            element={
              <ThemeProvider theme={themes[dataset.theme]}>
                <MainApp
                  pathogenName={dataset.pathogenName}
                  mutsDisabled={dataset.mutsDisabled}
                  tiparsDisabled={dataset.tiparsDisabled}
                  globalDataFilteringDisabled={dataset.globalDataFilteringDisabled}
                  globalDataFilteringDisabledForced={dataset.globalDataFilteringDisabledForced}
                  apiURL={(process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_API_URL : "/api/") + dataset.apiURL}
                />
              </ThemeProvider>
            }
          />
        ))}

      <Route path="/useCase1" element={<Usecase1 />} />
      <Route path="/useCase2" element={<Usecase2 />} />
      <Route path="/useCase3" element={<Usecase3 />} />
      <Route path="/useCase4" element={<Usecase4 />} />
      <Route path="/TreeVisualisation" element={<TreeVisualisation />} />
      <Route path="/TreePartitioning" element={<TreePartitioning />} />
    </Routes>
  );
}

export default App;
